<template>
  <div class="white upload-screen-1-container">
    <div class="important-details-container">
      <!--div class="back-icon text-xs-left">
        <v-icon>keyboard_backspace</v-icon>
      </div-->
      <div class="important-details">Important details</div>
    </div>
    <hr class="hr-text">

    <v-layout row wrap class="img-and-caption-container">
        <v-flex xs4 md1 class="img-container">
          <img src="https://res.cloudinary.com/viewzzz/image/upload/w_auto/v1523306017/dpfvh28om5ef75hlbdtc.jpg"/>
        </v-flex>
      <v-flex xs8 md11 class="caption-container">
        <textarea class="caption-text-area" placeholder="Write a caption…"></textarea>
      </v-flex>
    </v-layout>


    <!-- emotional -->
    <div class="input-container">
      <div class="input-label text-xs-left">Describe emotional appeal</div>
      <input class="img-desc-input" placeholder="romantic, relaxing, energetic, weird…"/>
    </div>

    <!-- address -->
    <div class="input-container">
      <div class="input-label text-xs-left">Photo was taken from</div>
      <input class="img-desc-input" placeholder="street, bar, hotel room, 4th floor…"/>
    </div>


    <!-- location -->
    <div class="input-container">
      <v-icon class="location-icon blue--text">keyboard_arrow_right</v-icon>
      <div class="input-label text-xs-left ">Location</div>
      <div class="input-container-text">
        ISB, Gachibowli, Hyderabad, Telangana 500032, India
      </div>
    </div>


    <!-- public access -->
    <div class="input-container">
      <div class="public-access-toggle blue--text">
        <v-switch
          v-model="switchToggle"
        ></v-switch>
      </div>
      <div class="input-label text-xs-left">Public access</div>
      <div class="input-container-text">
        Please UNSELECT, if photo was taken from a private property and it is not allowed for everyone to visit this spot.
      </div>
    </div>


  </div>
</template>

<script>
  export default {
    data () {
      return {
        switchToggle: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .upload-screen-1-container {
    height: 100vh;
    width: 100%;
    padding: 25px;
    .hr-text {
      line-height: 1em;
      position: relative;
      outline: 0;
      border: 0;
      color: black;
      text-align: center;
      height: 1.5em;
      opacity: .5;
      &:before {
        content: '';
        background: #818078;
        position: absolute;
        left: 0;
        top: 50%;
        width: 100%;
        height: 1px;
      }
      &:after {
        margin-top: -6px;
        font-size: 24px;
        -webkit-font-feature-settings: 'liga';
        position: relative;
        margin-left: -100%;
        display: inline-block;
        font-family: 'Material Icons';
        content: "keyboard_backspace";
        -webkit-font-feature-settings: 'liga' 1;
        -moz-font-feature-settings: 'liga' 1;
        font-feature-settings: 'liga' 1;

        padding: 0 .5em;
        line-height: 1.5em;
        // this is really the only tricky part, you need to specify the background color of the container element...
        color: #818078;
        background-color: #fcfcfa;
      }
    }
    .input-container {
      margin-bottom: 15px;
      width: 100%;
      position: relative;
      .public-access-toggle {
        top:0;
        right: 20px;
        position: absolute;
      }
      .location-icon {
        top:40%;
        right: 20px;
        position: absolute;
      }
      .input-label {
        text-align: left;
        font-size: 1.286em;
        font-weight: 700;
      }
      .img-desc-input {
        width: 100%;
        height: 100%;
        outline: none;
        ::placeholder {
          font-size: 1em;
        }
      }
      .input-container-text {
        font-size: 0.857em;
        text-align: left;
        margin-right: 35px;
      }
    }
    .important-details-container {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      position: relative;

      .back-icon {
        position: absolute;
        left: 0;
        top: 58%
      }
      .important-details {
        width: 98%;
        text-align: right;
        font-size: 1.286em;
        font-weight: 700;
      }
      .hr-div {
        margin-left: 20px ;
        position: absolute;
        width: 90%;
        top: 58%;
        left: 20px;
        background: lightgrey;
        height: 1px;
      }
    }
    .img-and-caption-container {
      border-bottom: 1px solid lightgrey;
      margin: 19px 0 9px 0;
      .img-container {
        img {
          width: 6.429em;
          height: 4.286em;
          object-fit: cover;
        }
      }
      .caption-container {
        padding-left: 10px;
        text-align: left;
        .caption-text-area {
          width: 100%;
          height: 100%;
          outline: none;
          resize: none;
          ::placeholder {
            font-size: 1em;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// uploadScreen-1.vue?cfe14552